import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9ed9404"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "summary__item-cc-icon",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M22 9v8a2 2 0 01-2 2H4a2 2 0 01-2-2V7a2 2 0 012-2h16a2 2 0 012 2v2zm0 0H6",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "summary__item-cc-number" }
const _hoisted_8 = { class: "summary__item-cc-number--last-four" }
const _hoisted_9 = {
  key: 1,
  class: "d-flex align-items-center my-2 summary__item-po"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "summary__item-cc-icon",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 21.4V2.6a.6.6 0 01.6-.6h11.652a.6.6 0 01.424.176l3.148 3.148A.6.6 0 0120 5.75V21.4a.6.6 0 01-.6.6H4.6a.6.6 0 01-.6-.6zM8 10h8M8 18h8M8 14h4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary__item-cc-number" }, [
  /*#__PURE__*/_createTextVNode("Your account is subscribed via "),
  /*#__PURE__*/_createElementVNode("strong", null, "purchase order"),
  /*#__PURE__*/_createTextVNode(". Contact your Ditto representative to make subscription changes.")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "summary__item-cc-icon",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 6v6h6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_13 = { class: "summary__item-cc-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.card && _ctx.userSubscriptionStatus === 'STRIPE')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            (_ctx.cardBrand === 'visa' || _ctx.cardBrand === 'mastercard')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "summary__item-cc-image",
                  src: require('../../../assets/images/' + _ctx.cardBrand + 'Logo.png')
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6)),
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode("●●●● ●●●● ●●●● "),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.card.last4), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.userSubscriptionStatus === 'PO')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_10,
                _hoisted_11
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.userSubscriptionStatus === 'TRIAL')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, [
                  _createTextVNode("Your Ditto trial has "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.planDaysRemaining), 1),
                  _createTextVNode(".")
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]))
  ]))
}